export class ImageUploader {
  folder: string | null = null;
  image: any = {};
}
